
        window.pug_templates['websockets_popover'] = window.pug_mixins['websockets_popover'] = function(ws) {
          var pug_interp, attributes = this.attributes || {}, block = this.block || false;
          window.pug_mixin_level++;
      const connected = ws.connected();
const state = ws.state();
const subs = ws.subscriptions();
if (connected) {
pug_html = pug_html + "\u003Cdiv class=\"d-flex\"\u003E\u003Cdiv class=\"btn btn-reconnect btn-secondary btn-sm w-100 mr-1\"\u003E\u003Ci class=\"fa fa-retweet\"\u003E \u003C\u002Fi\u003E\u003Cspan\u003EReconnect \u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["btn","btn-toggle-state","btn-sm","w-100","ml-1",state === 'play' ? 'btn-warning' : 'btn-success'], [false,false,false,false,false,true]), false, true)) + "\u003E\u003Ci" + (pug.attr("class", pug.classes(["fa",`fa-${state === 'play' ? 'pause' : 'play'}`], [false,true]), false, true)) + "\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = state == 'play' ? 'Pause' : 'Play') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"mt-2 mb-1\"\u003ESubscriptions\u003C\u002Fh2\u003E\u003Cdiv class=\"subscriptions\" style=\"overflow-y: auto; overflow-x: hidden; max-height: 80vh;\"\u003E\u003Cul class=\"list-group list-group-compact\"\u003E";
if (!subs.length) {
pug_html = pug_html + "\u003Cli class=\"list-group-item text-center p-4\"\u003E \u003Cp class=\"text-center mb-0\"\u003EYou're not subscribed to any channels\u003C\u002Fp\u003E\u003C\u002Fli\u003E";
}
// iterate subs
;(function(){
  var $$obj = subs;
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var sub = $$obj[pug_index8];
pug_html = pug_html + "\u003Cli" + (" class=\"list-group-item subscription\""+pug.attr("data-channel", sub.name, true, true)) + "\u003E\u003Cdiv class=\"d-flex align-items-center\"\u003E\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = sub.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-grow-1 text-right message-id\"\u003E";
if (sub.message_id) {
pug_html = pug_html + "\u003Cspan class=\"badge badge-secondary\"\u003E" + (pug.escape(null == (pug_interp = sub.message_id) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"btn btn-unsubscribe btn-danger btn-sm ml-3 mr-n1\"\u003E\u003Ci class=\"fa fa-trash-alt\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var sub = $$obj[pug_index8];
pug_html = pug_html + "\u003Cli" + (" class=\"list-group-item subscription\""+pug.attr("data-channel", sub.name, true, true)) + "\u003E\u003Cdiv class=\"d-flex align-items-center\"\u003E\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = sub.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-grow-1 text-right message-id\"\u003E";
if (sub.message_id) {
pug_html = pug_html + "\u003Cspan class=\"badge badge-secondary\"\u003E" + (pug.escape(null == (pug_interp = sub.message_id) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"btn btn-unsubscribe btn-danger btn-sm ml-3 mr-n1\"\u003E\u003Ci class=\"fa fa-trash-alt\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cp class=\"text-center mb-0\"\u003EDisconnected from server\u003C\u002Fp\u003E";
}

          window.pug_mixin_level--;
          if (window.pug_mixin_level < 1) { var result = pug_html; pug_html=""; return result; }
        };
      